import { rtkApi } from 'app/store/AppStore.rtk'
import dayjs from 'dayjs'
import {
  CalendarOptions,
  CalendarRequest,
  CalendarResponse,
  District,
  LeagueListResponse,
  School,
  SportListResponse,
  State,
} from 'types'

export const initApi = rtkApi
  .enhanceEndpoints({
    addTagTypes: [
      'state',
      'districts',
      'leagues',
      'sports',
      'school',
      'calendar',
      'backgroundImage',
    ],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getStateByIds: build.query<State[], string[]>({
        query: (stateIds) => {
          return {
            url: '/states/ByIds',
            method: 'POST',
            body: stateIds,
          }
        },
        providesTags: ['state'],
      }),

      getSchoolByIds: build.query<School[], string[]>({
        query: (schoolIds) => {
          return {
            url: '/school/ByIds',
            method: 'POST',
            body: schoolIds,
          }
        },
        providesTags: ['school'],
      }),

      getDistricts: build.query<District[], string[]>({
        query: (stateIds) => {
          return {
            url: '/districts/districtsByIds',
            method: 'POST',
            body: {
              ids: stateIds,
            },
          }
        },
        providesTags: ['districts'],
      }),

      getLeagues: build.query<LeagueListResponse, string>({
        query: () => {
          return {
            url: `/leagues`,
            params: {
              isActive: true,
              page: 1,
              perPage: 500,
            },
          }
        },
        providesTags: ['leagues'],
      }),

      getSports: build.query<SportListResponse, void>({
        query: () => {
          return {
            url: `/sports`,
            params: {
              page: 1,
              perPage: 500,
            },
          }
        },
        providesTags: ['sports'],
      }),

      getCalendarV3: build.query<CalendarResponse, CalendarOptions>({
        query: (request: CalendarOptions) => {
          const { state, district, school, sport, league, isLeague } = request
          const from = dayjs().subtract(6, 'month').format('YYYY-MM-DD')
          const to = dayjs().add(6, 'month').format('YYYY-MM-DD')

          const params: CalendarRequest = {
            from,
            to,
            disableCache: true,
          }

          if (state !== null && state.length > 0) {
            params.stateIds = state
          }

          if (district !== null) {
            params.districtIds = district
          }

          if (school !== null) {
            params.schoolIds = school
          }

          if (sport !== null) {
            params.sportIds = sport
          }

          if (league !== null) {
            params.leagueIds = league
          }

          if (isLeague !== null) {
            params.isLeague = isLeague
          }

          return {
            url: `/games/v3/getCalendar`,
            method: 'POST',
            body: params,
          }
        },
        providesTags: ['calendar'],
      }),

      getBackgroundImage: build.query<{ url: string }, string>({
        query: (imageId) => ({
          url: `/images/${imageId}`,
        }),
        providesTags: ['backgroundImage'],
      }),
    }),
  })

export const {
  useGetStateByIdsQuery,
  useGetDistrictsQuery,
  useGetLeaguesQuery,
  useGetSportsQuery,
  useGetSchoolByIdsQuery,
  useGetCalendarV3Query,
  useGetBackgroundImageQuery,
} = initApi
